import { CustomizedFields } from 'models';
import { SET_OBJECT_NAME, SET_SEARCH_KEY, SET_SEARCH_RESULTS, SET_SELECTED_ACCOUNT_ID, RESET } from './actionTypes';

const initialState = {
  objectName: '',
  searchKey: '',
  selectedAccountId: '',
  searchResults: {
    metaData: [],
    details: [],
  }
};

const attachAccount = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_OBJECT_NAME:
      const { name } = payload;
      return {
        ...state,
        objectName: name,
      };

    case SET_SEARCH_KEY:
      const { searchKey } = payload;
      return {
        ...state,
        searchKey
      };

    case SET_SEARCH_RESULTS:
      const { results } = payload;
      const parseMetaData = results.selector_meta.data.map(meta => {
        const {
          id,
          field_name,
          field_label,
          is_sys_auto,
          crm_data_type,
          lookup_own_field_name,
          model_type,
          is_restricted_to_me
        } = meta;
        if (!CustomizedFields[crm_data_type]) {
          console.log('No such type');
          return null;
        }
        return new CustomizedFields[crm_data_type]({
          id,
          name: field_name,
          label: field_label,
          isSystemField: is_sys_auto,
          lookupKey: lookup_own_field_name,
          modelType: model_type,
          type: crm_data_type,
          restriction: is_restricted_to_me
        });
      });
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          metaData: parseMetaData,
          details: results.index.data,
        }
      };

    case SET_SELECTED_ACCOUNT_ID:
      const { accountId } = payload;
      return {
        ...state,
        selectedAccountId: accountId,
      };

    case RESET:
      return initialState;

    default:
      return state;
  }
};

export default attachAccount;



// WEBPACK FOOTER //
// ./src/views/AttachAccount/flow/reducer.js